<form [formGroup]="tokenForm">
  <ion-grid>
    <ion-row class="ion-align-items-center ion-justify-content-start margin-mobile" s-height-100vh>
      <ion-col>
        <ion-row class="ion-align-items-center ion-justify-content-start" max-width-form>
          <ion-col size="12">
            <h1 class="title ion-text-center">
              {{'SIGNATURE.WE_SEND_A_TOKEN_TO_YOUR_EMAIL' | translate}}
            </h1>
            <h2 class="title ion-text-center">
              {{ email }}
            </h2>
          </ion-col>
          <ion-col size="12">
            <ion-label position="stacked">{{'SIGNATURE.TOKEN' | translate}}</ion-label>
            <ion-input
            formControlName="interveningSignatureToken"
            placeholder="{{'SIGNATURE.ENTER_THE_TOKEN_RECEIVED_' | translate}}"
            >
            </ion-input>
            <ion-note
              class="ion-margin-top ion-text-center"
              color="danger"
              *ngIf="interveningSignatureToken.dirty && interveningSignatureToken.errors?.required"
            >
            {{'SIGNATURE.INSERT_THE_TOKEN' | translate}}
            </ion-note>
          </ion-col>
          <ion-col class="ion-margin-top" size="10" (click)="resend()">
            <label pointer class="text-white resend">{{'SIGNATURE.DIDNT_RECEIVE_THE_TOKEN' | translate}}</label>
          </ion-col>
          <ion-col size="6" class="ion-margin-top">
            <ion-button expand="block" fill="outline" color="buttonPrimary" (click)="download()">
              {{'SIGNATURE.TO_VIEW_REPORT' | translate}}
            </ion-button>
          </ion-col>
          <ion-col size="6" class="ion-margin-top">
            <ion-button expand="block" color="buttonPrimary" (click)="sign(tokenForm)">
              {{'SIGNATURE.TO_SIGN' | translate}}
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-grid>
</form>
